var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeePot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50079 5.75C3.50079 5.05964 4.06073 4.5 4.75145 4.5H5.18918L5.81451 9.5H20.1971L20.8695 4.12403C20.9441 3.52718 20.4785 3 19.8767 3H4.75145C3.23187 3 2 4.23122 2 5.75V9.75C2 10.1642 2.33596 10.5 2.7504 10.5C3.16483 10.5 3.50079 10.1642 3.50079 9.75V5.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08685 14.8475L4.5215 14.7027C7.42826 13.7343 10.6009 13.9596 13.3414 15.3292C15.7259 16.5208 18.4864 16.7169 21.0155 15.8743L22 15.5463C21.8849 13.4869 20.853 11.8378 20.0095 11H6.0021C5.25638 11.7408 4.36335 13.1156 4.08685 14.8475Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02148 16.4504C4.11336 17.632 4.52427 18.9185 5.4331 20.245C5.771 20.7382 6.34862 21 6.9467 21H19.065C19.663 21 20.2407 20.7382 20.5786 20.245C21.308 19.1803 21.7167 18.1413 21.8971 17.1617L21.4901 17.2973C18.5834 18.2657 15.4108 18.0404 12.6702 16.6708C10.2857 15.4792 7.52527 15.2831 4.99613 16.1257L4.02148 16.4504Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeePot);
export default __webpack_public_path__ + "static/media/coffee-pot.d89f60b2c2708d94682c1b75521da4f9.svg";
export { ForwardRef as ReactComponent };